import { render, staticRenderFns } from "./ChatProject.vue?vue&type=template&id=1b4c4882&"
import script from "./ChatProject.vue?vue&type=script&lang=js&"
export * from "./ChatProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports